/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["form-button button{width:8em!important;justify-content:center}@media (min-width:380px){  form-button button{white-space:nowrap}}"];
export { styles as styles };
